import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import {
  filterToQuery,
  inputText,
  matchSuggestion,
  OptionRenderer,
} from "../../customerDebtPayments/common/CustomSelectOption";

const customerDebtCorrectionFilterList = (permissions) => {
  const defaultFilter = [
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="date"
      label="mine.label.date"
      variant="outlined"
    />,
    <ReferenceInput
      alwaysOn
      source="customer_id"
      reference="customers"
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={10}
    >
      <AutocompleteInput
        resettable
        variant="outlined"
        label="mine.label.customer"
        optionValue="id"
        optionText={<OptionRenderer />}
        inputText={inputText}
        matchSuggestion={matchSuggestion}
        filterToQuery={filterToQuery}
        sx={{ minWidth: "400px" }}
      />
    </ReferenceInput>,
    <TextInput
      alwaysOn
      source="note"
      label="mine.label.note"
      resettable
      variant="outlined"
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default customerDebtCorrectionFilterList;
